// Contact.tsx
import "./styles.scss";

import React, { useState } from "react";
import Header from "../../components/header";
import { Container, Row, Col } from "react-bootstrap";
import { Button, Form, Input, notification } from "antd";
import API from "../../config/api";
import { POST } from "../../utils/apiCalls";
import { AiOutlineWhatsApp } from "react-icons/ai";
import { IoMailOutline } from "react-icons/io5";
import { PiPhoneCall } from "react-icons/pi";
import { HiOutlineOfficeBuilding } from "react-icons/hi";
import TextArea from "antd/es/input/TextArea";
import Footer from "../../components/footer";

const Contact: React.FC = () => {
  const [form] = Form.useForm();
  const [notificationApi, contextHolder] = notification.useNotification();
  const [isLoading, setIsLoading] = useState(false);

  const submitHandler = async (values: any) => {
    try {
      setIsLoading(true);
      const response: any = await POST(API.CONTACT_CREATE, values);
      if (response?.status) {
        form.resetFields();
        notificationApi.success({
          duration: 8,
          placement: "top",
          message:
            "Thank you for reaching out! Your inquiry has been received, and our team will get back to you within the next 24 hours. We appreciate your interest and look forward to assisting you.",
        });
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="contactScreen">
      {contextHolder}
      <Header />
      <div className="contactScreen-content">
        <Container fluid={false}>
          <Row>
            <Col md={10} xs={12} className="mx-auto">
              <Row>
                <Col md={6} xs={12}>
                  <h2 className="contactScreen-txt1">Connect with Us</h2>
                  <div className="map-container">
                    <iframe
                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3888.519515332315!2d75.994425!3d11.482545!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba66deaf70c83cd%3A0x6cca385417bef6b5!2sbairuha+tech!5e0!3m2!1sen!2sin!4v1724761234567!5m2!1sen!2sin"
                      width="100%"
                      height="300"
                      style={{ border: 0, borderRadius: "10px" }}
                      allowFullScreen
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                    ></iframe>
                  </div>
                  <div className="contact-info">
                    <div className="contact-item">
                      <div className="icon-box">
                        <AiOutlineWhatsApp size={32} color="green" />
                      </div>
                      <div>
                        <div>Whatsapp</div>
                        <span className="contact-text">+91 73065 69687</span>
                      </div>
                    </div>
                    <div className="contact-item">
                      <div className="icon-box">
                        <PiPhoneCall size={32} color="#3c4b9e" />
                      </div>
                      <div>
                        <div>Customer Support</div>
                        <span className="contact-text">+91 73065 69687</span>
                      </div>
                    </div>
                    <div className="contact-item">
                      <div className="icon-box">
                        <IoMailOutline size={32} color="#000" />
                      </div>
                      <div>
                        <div>Mail</div>
                        <span className="contact-text">
                          info@xentrybook.com
                        </span>
                      </div>
                    </div>
                    <div className="contact-item">
                      <div className="icon-box">
                        <HiOutlineOfficeBuilding size={32} color="#ba6c6c" />
                      </div>
                      <div>
                        <div>Corporate Headquarters</div>
                        <span className="contact-text">
                          Bairuhatech, Digital Bridge International Markaz
                          Knowledge City Kannoth, Kozhikode, Kerala, 673580
                        </span>
                      </div>
                    </div>
                    <div className="contact-item">
                      <div className="icon-box">
                        <HiOutlineOfficeBuilding size={32} color="#6c6cba" />
                      </div>
                      <div>
                        <div>Customer Support Center</div>
                        <span className="contact-text">
                          Ridnat Digital and Secure World, Ground floor, Tanveer
                          Complex, English church cross road, Nadakkavu,
                          Calicut-673011
                        </span>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col md={1} />
                <Col md={5} xs={12}>
                  <h2 className="contactScreen-txt1">Drop a Message</h2>
                  <div className="contactScreen-box1">
                    <Form
                      form={form}
                      onFinish={submitHandler}
                      layout="vertical"
                    >
                      <Form.Item
                        name="name"
                        label="Name"
                        rules={[
                          { required: true, message: "Name is required" },
                        ]}
                      >
                        <Input placeholder="Enter Your Name" size="large" />
                      </Form.Item>
                      <Form.Item
                        name="phone"
                        label="Phone"
                        rules={[
                          { required: true, message: "Phone is required" },
                        ]}
                      >
                        <Input
                          placeholder="Enter Your Phone Number"
                          size="large"
                        />
                      </Form.Item>
                      <Form.Item
                        name="email"
                        label="Email"
                        rules={[
                          { required: true, message: "Email is required" },
                        ]}
                      >
                        <Input placeholder="Enter Your Email" size="large" />
                      </Form.Item>
                      <Form.Item
                        name="message"
                        label="Message"
                        rules={[
                          { required: true, message: "Message is required" },
                        ]}
                      >
                        <TextArea
                          placeholder="Enter Your Message"
                          size="large"
                          rows={4}
                        />
                      </Form.Item>
                      <Form.Item>
                        <Button
                          block
                          size="large"
                          className="contactScreen-form-submit"
                          loading={isLoading}
                          htmlType="submit"
                          type="primary"
                        >
                          Send
                        </Button>
                      </Form.Item>
                    </Form>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
          <br />
          <br />
        </Container>
      </div>
      <Footer />
    </div>
  );
};

export default Contact;
